import { getSupabaseClient } from '../../../../core/supabase/client.js';
import type { AssessmentDbRow, AssessmentResponseDbRow } from '../dtos/AssessmentDto.js';

export class AssessmentRemoteDataSource {
  private get supabase() {
    return getSupabaseClient() as any;
  }

  async list(projectId: string): Promise<AssessmentDbRow[]> {
    const { data, error } = await this.supabase
      .from('assessments')
      .select('*')
      .eq('project_id', projectId)
      .eq('active', true)
      .order('created_at', { ascending: false });

    if (error) throw new Error(error.message);
    return data ?? [];
  }

  async getById(id: string): Promise<AssessmentDbRow | null> {
    const { data, error } = await this.supabase
      .from('assessments')
      .select('*')
      .eq('id', id)
      .maybeSingle();

    if (error) throw new Error(error.message);
    return data ?? null;
  }

  async create(row: Partial<AssessmentDbRow>): Promise<AssessmentDbRow> {
    const { data, error } = await this.supabase
      .from('assessments')
      .insert(row)
      .select('*')
      .single();

    if (error) throw new Error(error.message);
    return data;
  }

  async update(id: string, patch: Partial<AssessmentDbRow>): Promise<AssessmentDbRow> {
    const { data, error } = await this.supabase
      .from('assessments')
      .update(patch)
      .eq('id', id)
      .select('*')
      .single();

    if (error) throw new Error(error.message);
    return data;
  }

  async delete(id: string): Promise<void> {
    const { error } = await this.supabase
      .from('assessments')
      .update({ active: false })
      .eq('id', id);

    if (error) throw new Error(error.message);
  }

  async listResponses(assessmentId: string): Promise<AssessmentResponseDbRow[]> {
    const { data, error } = await this.supabase
      .from('assessment_responses')
      .select('*')
      .eq('assessment_id', assessmentId)
      .order('created_at', { ascending: false });

    if (error) throw new Error(error.message);
    return data ?? [];
  }
}
